import HttpService from './HttpService'

const _http = new HttpService()
export default {
  clearCache: () => {
    return _http.get(`/api/job/clear-cache`)
  }
}